import BaseModel from './base-model.js'
import { useSettings } from '@store/settings'
const $settings = useSettings()

class Service extends BaseModel {
    /**
     * Set the title of the model
     */
    title = $settings.labels.service?.singular

    /**
     * Set the id of the model
     */
    route = 'service'

    /**
     * Primary key of the model
     *
     * @var {string}
     */
    primaryKey = 'service_id'
}

export default Service